
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { ProjectDocument } from '@/models/project.model';
import { SCAPIN_GREEN, SCAPIN_ORANGE, SCAPIN_RED } from '@/configs/colors';
import { payloadStart, runnerState } from '@/store/stead/runner.store';
import { TerminalDocument } from "@/models/terminal.model";
import { fetchTerminals } from "@/axios/repository/terminal.axios";
import { lightToHeavy, StepHeavyDocument, StepLightDocument } from "@/models/step.model";

@Component
export default class SbSelectTerminalDialog extends Vue {
  // Les props
  @Prop() private debug!: boolean
  @Prop() private steps!: StepLightDocument[]
  @PropSync('show') private isVisible!: boolean

  // Les propriétés
  private termId: string = ''
  private terminals: TerminalDocument[] = []
  private msgConnexion: string = ''
  private showMsgConnexion: boolean = false
  private alertColor = SCAPIN_RED

  // Les propriétés calculées
  private get project(): ProjectDocument | null {
    return this.$store.state.current.Project
  }

  private get btnColor() {
    return this.debug ? SCAPIN_ORANGE : SCAPIN_GREEN
  }

  private get runner(): runnerState {
    return this.$store.state.runner
  }

  private get wsTermMessage() {
    return this.runner.connectMsg
  }

  private set wsTermMessage(msg: string) {
    this.$store.commit('runner/connectmsg', msg)
  }

  private get started() {
    return this.runner.ioTerm.started
  }

  // Les hooks
  public mounted() {
    this.loadTerminals()
  }

  // Les méthodes surveillées
  @Watch('wsTermMessage')
  private showWsTermMessage() {
    if (this.wsTermMessage.length) {
      this.msgConnexion = this.wsTermMessage
      this.showMsgConnexion = true
    }
  }

  @Watch('started')
  private changeStarted() {
    if (this.started) {
      this.isVisible = false
      this.showMsgConnexion = false
      this.msgConnexion = ''
    }
  }

  @Watch('isVisible')
  private changeVisible( ) {
    if (this.isVisible) {
      this.showMsgConnexion = false
      this.wsTermMessage = ''
    }
  }

  @Watch('project')
  private onChangeProject() {
    this.loadTerminals()
  }

  // Les méthodes d'instance
  private async loadTerminals() {
    if (this.project) {
      const termDocs = await fetchTerminals(this.project._id)
      this.terminals = termDocs.filter(t => t.fordebug).sort((a, b) => {
        const na = a.name.toLowerCase()
        const nb = b.name.toLowerCase()
        return na > nb ? 1 : nb > na ? -1 : 0
      })
      if (this.terminals.length > 0 && this.termId.length === 0) {
        this.termId = this.terminals[0]._id
      }
    }
  }

  private onClickBtn() {
    if (this.termId.length) {
      // console.log('onClickBtn terminal :', this.termId)
      this.$store.dispatch('runner/start', {
        db: this.$store.state.baseUrl,
        termid: this.termId,
        steps: this.steps.map<StepHeavyDocument>(s => lightToHeavy(s) as StepHeavyDocument ) ,
        debug: this.debug
      } as payloadStart)
    } else {
      console.log('onClickBtn terminal : null')
    }
  }

  // Les méthodes statiques
}
